import type { AsyncBelongsTo } from '@ember-data/model';
import Model, { attr, belongsTo } from '@ember-data/model';
import type LocationModel from 'garaje/models/location';

export default class PrinterAlertConfigurationModel extends Model {
  // attributes
  @attr('array', { defaultValue: () => [] })
  declare errorTypes: number[];

  @attr('boolean', { defaultValue: false })
  declare enabled: boolean;

  @attr('array', { defaultValue: () => [] })
  declare recipientIds: number[];

  @attr('array', { defaultValue: () => [0] })
  declare notificationChannels: number[];

  // relationships
  @belongsTo('location', { async: true, inverse: null })
  declare location: AsyncBelongsTo<LocationModel>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'printer-alert-configuration': PrinterAlertConfigurationModel;
  }
}
